'use client'

import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { authApi } from '../api'
import type { ForgotPasswordInput } from '../schemas'

export function useForgotPassword() {
  return useMutation({
    mutationFn: (input: ForgotPasswordInput) => authApi.forgotPassword(input),
    onSuccess: () => {
      toast.success('Se o email existir, um link de recuperacao foi enviado')
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Falha ao enviar email')
    },
  })
}
